import { render } from "./CreateCredential.vue?vue&type=template&id=67a455bf"
import script from "./CreateCredential.vue?vue&type=script&lang=js"
export * from "./CreateCredential.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__